import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from 'rxjs';
import { EventService } from '../services/event.service';
import {first, map} from "rxjs/operators";

@Injectable()
export class ToolboxContentResolver implements Resolve<any> {
    constructor(
        private eventService: EventService
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any>|Promise<any>|any {
        return this.eventService.getToolboxContent(this.getAdoptedEventId())
            .pipe(map(res => res.AdoptedEvent[0])
            ,first());
    }

	getAdoptedEventId() {
		return this.eventService.selectedEvent.gql.Participant[0].adoptedEvent.adoptedEventId;
	}
}
